import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export interface Providers {
  google: boolean;
  signup: boolean;
  /** AI features are enabled on the server (AI_ENABLED and a provider). */
  ai: boolean;
  /** Unsplash photo search is configured on the server. */
  stock?: boolean;
}

/** Server-side switches that change what the UI offers; public, so the landing can use it too. */
export function useProviders() {
  return useQuery({
    queryKey: ['auth-providers'],
    queryFn: () => api<Providers>('/api/auth/providers', { workspace: false }),
    staleTime: 5 * 60_000,
  });
}

/** True only once the server confirmed AI is on — nothing AI-related flashes while loading. */
export function useAiEnabled(): boolean {
  return useProviders().data?.ai === true;
}

/** Free stock photos (Unsplash) can be searched and used. */
export function useStockEnabled(): boolean {
  return useProviders().data?.stock === true;
}
